import type { CSSProperties, ReactNode } from "react";
import { C } from "../theme";

interface LabelProps {
  children: ReactNode;
  style?: CSSProperties;
}

/** Rótulo de seção em caixa alta (uppercase, espaçado). */
export function Label({ children, style }: LabelProps) {
  return (
    <div
      style={{
        fontSize: 10.5,
        letterSpacing: 1.6,
        textTransform: "uppercase",
        color: C.light,
        fontWeight: 600,
        marginBottom: 6,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
